import { render, staticRenderFns } from "./Ratings.vue?vue&type=template&id=17906032"
import script from "./Ratings.vue?vue&type=script&lang=js"
export * from "./Ratings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/myskilliz_new/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('17906032')) {
      api.createRecord('17906032', component.options)
    } else {
      api.reload('17906032', component.options)
    }
    module.hot.accept("./Ratings.vue?vue&type=template&id=17906032", function () {
      api.rerender('17906032', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/views/rh/gestion/rating/Ratings.vue"
export default component.exports